var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20L7.6 18.6L9.35 16.8C7.21667 16.5167 5.45833 15.9333 4.075 15.05C2.69167 14.1667 2 13.15 2 12C2 10.6167 2.9625 9.4375 4.8875 8.4625C6.8125 7.4875 9.18333 7 12 7C14.8167 7 17.1875 7.4875 19.1125 8.4625C21.0375 9.4375 22 10.6167 22 12C22 13.0333 21.4458 13.9583 20.3375 14.775C19.2292 15.5917 17.7833 16.2 16 16.6V14.55C17.2833 14.2167 18.2708 13.8042 18.9625 13.3125C19.6542 12.8208 20 12.3833 20 12C20 11.4667 19.2875 10.8333 17.8625 10.1C16.4375 9.36667 14.4833 9 12 9C9.51667 9 7.5625 9.36667 6.1375 10.1C4.7125 10.8333 4 11.4667 4 12C4 12.4 4.425 12.8792 5.275 13.4375C6.125 13.9958 7.33333 14.4167 8.9 14.7L7.6 13.4L9 12L13 16L9 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon360);
export default __webpack_public_path__ + "static/media/icon-360.0383425998aedd0546abec7f4594a9e4.svg";
export { ForwardRef as ReactComponent };